import { request } from "services/api/util";

class BookingService {
  getHeaders() {
    return {
      "content-type": "application/json;charset=UTF-8",
      "accept-language": "TH",
    };
  }

  async getBookings(params) {
    const config = {
      method: "get",
      url: `admin/bookings`,
      params: params,
      headers: this.getHeaders(),
    };
    return request(config);
  }

  async getBooking(id) {
    const config = {
      method: "get",
      url: `admin/bookings/${id}`,
      headers: this.getHeaders(),
    };
    return request(config);
  }

  async createBooking(data) {
    const config = {
      method: "post",
      url: `admin/bookings`,
      data: data,
      headers: this.getHeaders(),
    };
    return request(config);
  }

  async updateBooking(id, data) {
    const config = {
      method: "put",
      url: `admin/bookings/${id}`,
      data: data,
      headers: this.getHeaders(),
    };
    return request(config);
  }

  async getCalendar(params) {
    const config = {
      method: "get",
      url: `admin/bookings/calendar`,
      params: params,
      headers: this.getHeaders(),
    };
    return request(config);
  }

  async getBrands() {
    const config = {
      method: "get",
      url: `admin/bookings/brands`,
      headers: this.getHeaders(),
    };
    return request(config);
  }

  async getStores(param) {
    const config = {
      method: "get",
      url: `admin/bookings/stores`,
      params: param,
      headers: this.getHeaders(),
    };
    return request(config);
  }

  async getServices(param) {
    const config = {
      method: "get",
      url: `admin/bookings/services`,
      params: param,
      headers: this.getHeaders(),
    };
    return request(config);
  }

  async getRooms(param) {
    const config = {
      method: "get",
      url: `admin/bookings/rooms`,
      params: param,
      headers: this.getHeaders(),
    };
    return request(config);
  }

  async getStaffs(param) {
    const config = {
      method: "get",
      url: `admin/bookings/staffs`,
      params: param,
      headers: this.getHeaders(),
    };
    return request(config);
  }

  async getStatuses(param) {
    const config = {
      method: "get",
      url: `admin/bookings/statuses`,
      params: param,
      headers: this.getHeaders(),
    };
    return request(config);
  }

  async getPrivileges(param) {
    const config = {
      method: "get",
      url: `admin/bookings/privileges`,
      params: param,
      headers: this.getHeaders(),
    };
    return request(config);
  }

  async getVouchers(param) {
    const config = {
      method: "get",
      url: `admin/bookings/vouchers`,
      params: param,
      headers: this.getHeaders(),
    };
    return request(config);
  }

  async getDates(param) {
      const config = {
          method: "get",
          url: `admin/bookings/dates`,
          params: param,
          headers: this.getHeaders(),
      };
      return request(config);
  }

  async getTimes(param) {
    const config = {
      method: "get",
      url: `admin/bookings/times`,
      params: param,
      headers: this.getHeaders(),
    };
    return request(config);
  }

  async getCustomer(param) {
    const config = {
      method: "get",
      url: `admin/bookings/customer`,
      params: param,
      headers: this.getHeaders(),
    };
    return request(config);
  }

  async getSwappableRooms(params) {
    const config = {
      method: "get",
      params: params,
      url: `/admin/bookings/swappableRooms`,
      headers: this.getHeaders(),
    };
    return request(config);
  }

  async getSwappableStaffs(params) {
    const config = {
      method: "get",
      params: params,
      url: `/admin/bookings/swappableStaffs`,
      headers: this.getHeaders(),
    };
    return request(config);
  }
}

export default new BookingService();
